import QueryStatsIcon from '@mui/icons-material/QueryStats'
import { Box, Chip, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

export interface EmptyStateAgent {
  name: string
  description?: string
}

const STARTER_KEYS = [
  'caChat.thread.starter.whatInfo',
  'caChat.thread.starter.exampleQuestions',
]

export default function EmptyState(
  { agent, onStarter }: { agent?: EmptyStateAgent; onStarter?: (q: string) => void },
) {
  const intl = useIntl()
  const starters = STARTER_KEYS.map((k) => intl.formatMessage({ id: k }))
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
        px: 3,
        color: 'text.secondary',
      }}
    >
      <QueryStatsIcon sx={{ fontSize: 40, color: 'primary.main', opacity: 0.85 }} />
      <Typography variant="subtitle1" color="text.primary" sx={{ fontWeight: 600 }}>
        {agent
          ? intl.formatMessage({ id: 'caChat.thread.empty.title.named' }, { name: agent.name })
          : intl.formatMessage({ id: 'caChat.thread.empty.title.generic' })}
      </Typography>
      <Typography variant="body2">
        {agent?.description ||
          intl.formatMessage({ id: 'caChat.thread.empty.body.generic' })}
      </Typography>
      {onStarter && (
        <>
          <Typography variant="caption" sx={{ mt: 1.5, opacity: 0.8 }}>
            {intl.formatMessage({ id: 'caChat.thread.empty.starters.prompt' })}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
            {starters.map((q) => (
              <Chip
                key={q}
                label={q}
                variant="outlined"
                clickable={true}
                onClick={() => onStarter(q)}
                sx={{ height: 'auto', py: 0.5, '& .MuiChip-label': { whiteSpace: 'normal' } }}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}
